export default {
  text: 'Przygotowujemy Twój stolik 🍽…',
};
